import { useVideoStations } from '@app/core/stations/hooks/useVideoStations';
import LaunchIcon from '@mui/icons-material/Launch';
import { IconButton, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLivePlayerSettingsStore } from '../store/live-player-settings.store';

/**
 * Button that opens the current station's live player in a new tab (fullscreen)
 * and closes the global live player dialog.
 */
export function LivePlayerNewTabControl({ stationId }: { stationId: string }) {
  const { formatMessage } = useIntl();
  const close = useLivePlayerSettingsStore((state) => state.close);
  const stations = useVideoStations();

  const currentStation = useMemo(
    () => stations.find((s) => s.id === stationId) ?? null,
    [stations, stationId],
  );
  const canOpenExternal = Boolean(currentStation?.slug);

  const handleOpenExternal = () => {
    if (currentStation?.slug) {
      close();

      window.open(`/live-player/${currentStation.slug}?fullscreen=true&autoplay=true`, '_blank');
    }
  };

  return (
    <Tooltip
      title={formatMessage({
        id: 'livePlayer.toggle.mode.fullscreen',
        defaultMessage: 'Abrir en pantalla completa',
      })}
    >
      <span>
        <IconButton size="small" onClick={handleOpenExternal} disabled={!canOpenExternal}>
          <LaunchIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
